import { useContext } from 'react';
import { NovedadesContext } from 'contexts/novedadesContext/NovedadesContext';

export const useNovedadesContext = () => {
	return useContext(NovedadesContext);
};
